import { UPDATE_LOGINED_ACTION_TYPE } from './modules/actionTypes';

export const updateLogined = (token: string) => ({
  type: UPDATE_LOGINED_ACTION_TYPE,
  payload: token,
});

export type LoginedActionTypes = ReturnType<typeof updateLogined>;
